import { AlertTriangle } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { BtnOrange, BadgeSoon } from "@/components/bits";
import { usePreRegister } from "@/components/PreRegisterModal";
import { SOON_PAGES } from "@/data/site";

export default function ComingSoon({ cfgKey }) {
  const cfg = SOON_PAGES[cfgKey];
  const { openPreRegister } = usePreRegister();

  return (
    <div className="bg-white">
      <PageHero
        eyebrow={cfg.eyebrow}
        title={cfg.title}
        lead={cfg.text}
        image={cfg.image}
        imageAlt={cfg.imageAlt}
      />

      <section className="mx-auto max-w-4xl px-4 py-16 sm:px-6 md:py-20 lg:px-8">
        {cfg.extra && (
          <Reveal>
            <p className="text-lg leading-relaxed text-slate-700">{cfg.extra}</p>
          </Reveal>
        )}
        <Reveal delay={0.08}>
          <div className="mt-8 flex items-start gap-4 rounded-2xl border border-amber-300 bg-amber-50 p-6" data-testid="aviso-em-breve">
            <AlertTriangle className="h-6 w-6 shrink-0 text-amber-600" />
            <div>
              <BadgeSoon>Aviso</BadgeSoon>
              <p className="mt-2 text-sm font-semibold leading-relaxed text-amber-900 sm:text-base">{cfg.aviso}</p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.14}>
          <div className="mt-12 rounded-3xl bg-brand-obsidian px-6 py-12 text-center sm:px-12">
            <p className="font-mono text-xs font-semibold uppercase tracking-[0.3em] text-brand-orange">
              Lista de interesse
            </p>
            <h2 className="mx-auto mt-3 max-w-lg font-display text-2xl font-extrabold text-white">
              Quero saber quando estiver disponível.
            </h2>
            <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-slate-300">
              Deixe seu e-mail para receber um aviso quando {cfg.eyebrow} for lançado.
            </p>
            <BtnOrange
              data-testid="coming-soon-cta-pre-cadastro"
              onClick={() => openPreRegister({ interesse: cfg.interest, origem: cfg.slug.replace("/", "") })}
              className="mt-8"
            >
              Quero ser avisado
            </BtnOrange>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
